"use client";

import { Card, CardContent } from "@/components/ui/card";
import { Quote } from "lucide-react";

const testimonials = [
  {
    quote:
      "Prima perdevo due mattine a settimana solo a incrociare dati tra portali diversi. Ora carico il documento e ho già finito. A fine campagna SS ho recuperato €6.200 di provvigioni che avrei perso.",
    author: "Luca B.",
    role: "Agente plurimandatario",
    location: "Emilia-Romagna",
    initials: "LB",
  },
  {
    quote:
      "La mappa stagionale è la cosa che uso di più. In tre anni non avevo mai avuto un quadro chiaro di chi stava saltando la stagione. Adesso sì — e i riordini sono cresciuti del 20%.",
    author: "Elena F.",
    role: "Agente · 5 brand",
    location: "Veneto",
    initials: "EF",
  },
  {
    quote:
      "L'AI briefing prima della visita mi ha fatto chiudere un ordine che avrei perso perché non ricordavo la richiesta specifica del cliente. Game changer.",
    author: "Marco R.",
    role: "Agente mono-mandatario",
    location: "Lombardia",
    initials: "MR",
  },
];

const stats = [
  {
    value: "5-10h",
    label: "risparmiate a settimana",
    description: "di data entry automatizzato",
  },
  {
    value: "+20%",
    label: "aumento ordini",
    description: "dopo 6 mesi di utilizzo",
  },
  {
    value: "23%",
    label: "clienti ripescati",
    description: "grazie alla mappa del territorio",
  },
  {
    value: "48h",
    label: "setup medio",
    description: "per essere operativi",
  },
];

export function SocialProof() {
  return (
    <section className="py-20 md:py-32 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="container mx-auto max-w-6xl">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-ruby-600 mb-4">
            Testimonianze
          </span>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-mocha-950 tracking-tight mb-4">
            Cosa dicono gli agenti che usano KennyDB
          </h2>
          <p className="text-lg text-mocha-600 max-w-2xl mx-auto">
            Non credere a noi. Ascolta chi lo usa ogni giorno sul campo.
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-mocha-950 rounded-xl p-6 text-center"
            >
              <div className="font-serif text-3xl md:text-4xl font-bold text-honey-50 leading-none mb-2">
                {stat.value}
              </div>
              <div className="text-xs font-semibold text-honey-200 uppercase tracking-wide mb-1">
                {stat.label}
              </div>
              <div className="text-xs text-mocha-400">{stat.description}</div>
            </div>
          ))}
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((testimonial) => (
            <Card
              key={testimonial.author}
              className="border-ruby-100 hover:border-ruby-200 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
            >
              <CardContent className="p-6 md:p-8">
                {/* Quote icon */}
                <Quote className="w-8 h-8 text-ruby-200 mb-4" />

                {/* Quote text */}
                <blockquote className="font-serif text-lg text-mocha-800 italic leading-relaxed mb-6">
                  &ldquo;{testimonial.quote}&rdquo;
                </blockquote>

                {/* Author */}
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-honey-100 flex items-center justify-center text-sm font-bold text-ruby-600 shrink-0">
                    {testimonial.initials}
                  </div>
                  <div>
                    <div className="font-semibold text-mocha-950">
                      {testimonial.author}
                    </div>
                    <div className="text-xs text-mocha-500">
                      {testimonial.role} · {testimonial.location}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
